<!-- App.vue -->
<template>
    <div>
        <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Capture Your Problem</span>
                </h5>
    
            </CCol>
        <canvas ref="canvas" style="display: none;"></canvas>
        <video ref="video" autoplay></video>
        <div class="custom-card-camera text-center">
            <span @click="GoToSelected"><img src="../assets/img/image.png" @click="takePicture" /></span>
            <span><img src="../assets/img/Scan1.png" /></span>
            <span @click="startCamera"><img src="../assets/img/Camera.png" style="width:16px"/></span>
        </div>
        <!-- <button @click="startCamera">Open Camera</button>
          
            <button @click="takePicture">Take Picture</button> -->
        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:50%" src="../assets/img/geniepopup.png" />
                    <h3 class="custom-16px-500 text-center">Genie is analyzing your photo. It will be converted to your wish</h3>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            videoStream: null,
            isLanguagePopupVisible: false,
        };
    },
    methods: {
        async startCamera() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.$refs.video.srcObject = stream;
                this.videoStream = stream;
            } catch (error) {
                console.error('Error accessing camera:', error);
            }
        },
        takePicture() {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;
            const context = canvas.getContext('2d');

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            // You can now access the image data in the canvas and send it to the server or perform other actions.

            // Stop the video stream to release the camera.
            this.videoStream.getTracks().forEach(track => track.stop());

            this.isLanguagePopupVisible = true;
          
        },
        GoToSelected() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        closePopup() {
            this.isLanguagePopupVisible = false;
            this.$router.push("CaptureDetail");
        },
    },
};
</script>
  
<style>
/* Add your styles here if needed */
</style>
  